const labelsData = {
  sites: [
    {
      title: "THE FORGE",
      rotation: -0.102509,
      distance: 2.281004,
      altitude: 2,
      path: "/images/sites/labels/forge.png",
      image: null
    },
    {
      title: "RED LION COURT",
      rotation: -6.132655,
      distance: 2.466665,
      altitude: 5,
      path: "/images/sites/labels/lion.png",
      image: "/textures/landsec/square/lion_500x500.webp"
    },
    {
      title: "BRIDGE ROAD",
      rotation: -0.095934,
      distance: 2.36178,
      altitude: 25,
      path: "/images/sites/labels/bridge.png",
      image: "/textures/landsec/square/bridge_500x500.webp"
    },
    {
      title: "THE LIBERTY OF SOUTHWARK",
      rotation: -0.266676,
      distance: 2.713522,
      altitude: 20,
      path: "/images/sites/labels/liberty.png",
      image: "/textures/landsec/square/liberty_500x500.webp"
    },
    {
      title: "TIMBER SQUARE",
      rotation: -1.356765,
      distance: 3.301578,
      altitude: 7,
      path: "/images/sites/labels/timber.png",
      image: "/textures/landsec/square/timber_500x500.webp"
    }
  ],
  culture: [
    {
      title: "BOROUGH MARKET",
      rotation: -0.028,
      distance: 2.708487,
      altitude: 5,
      path: "/images/sites/labels/borough.png",
      image: "/textures/culture/borough.webp"
    },
    {
      title: "SOUTHWARK CATHEDRAL",
      rotation: -6.243959,
      distance: 2.792237,
      altitude: 5,
      path: "/images/sites/labels/cathedral.png",
      image: "/textures/culture/cathedral.webp"
    },
    {
      title: "SHAKESPEARE'S GLOBE",
      rotation: -5.714215,
      distance: 2.23195,
      altitude: 5,
      path: "/images/sites/labels/globe.png",
      image: "/textures/culture/globe.webp"
    },
    {
      title: "FLAT IRON SQUARE",
      rotation: -0.335552,
      distance: 2.570955,
      altitude: 5,
      path: "/images/sites/labels/iron.png",
      image: "/textures/culture/iron.webp"
    },
    {
      title: "VINEGAR YARD",
      rotation: -0.188752,
      distance: 3.271535,
      altitude: 5,
      path: "/images/sites/labels/vinegar.png",
      image: "/textures/culture/vinegar.webp"
    },
  ],
  transport: [
    {
      title: "BLACKFRIARS STATION",
      rotation: -3.853442,
      distance: 2.336361,
      altitude: 2,
      path: "/images/sites/labels/blackfriars.png",
      image: "/textures/transport/blackfriars.webp"
    },
    {
      title: "CANNON STREET",
      rotation: -5.593251,
      distance: 2.731077,
      altitude: 2,
      path: "/images/sites/labels/cannon.png",
      image: "/textures/transport/cannon.webp"
    },
    {
      title: "LONDON BRIDGE",
      rotation: -6.228836,
      distance: 2.935524,
      altitude: 2,
      path: "/images/sites/labels/londonBridge.png",
      image: "/textures/transport/londonBridge.webp"
    },
    {
      title: "MANSION HOUSE",
      rotation: -5.324092,
      distance: 2.572213,
      altitude: 2,
      path: "/images/sites/labels/mansion.png",
      image: "/textures/transport/mansion.webp"
    },
    {
      title: "MONUMENT STATION",
      rotation: -5.678126,
      distance: 3.005716,
      altitude: 2,
      path: "/images/sites/labels/monument.png",
      image: "/textures/transport/monument.webp"
    },
    {
      title: "SOUTHWARK STATION",
      rotation: -2.025266,
      distance: 2.498037,
      altitude: 2,
      path: "/images/sites/labels/southwark.png",
      image: "/textures/transport/southwark.webp"
    },
    {
      title: "WATERLOO STATION",
      rotation: -2.326055,
      distance: 2.754881,
      altitude: 2,
      path: "/images/sites/labels/waterloo.png",
      image: "/textures/transport/waterloo.webp"
    },
  ],
  other: [
    {
      title: "St THOMAS HOSPITAL",
      rotation: -2.249189,
      distance: 3.041094,
      altitude: 2,
      path: "/images/sites/labels/thomas.png",
      image: "/textures/other/thomas.webp"
    },
    {
      title: "GUYS HOSPITAL",
      rotation: -0.2,
      distance: 2.799455,
      altitude: 5,
      path: "/images/sites/labels/guys.png",
      image: "/textures/other/guys.webp"
    }
  ],
}

export default labelsData